const getters = {
  // errorLogs: state => state.errorLog.logs
};
export default getters;
